import appStoreBadgeCs from "Assets/Images/Images/app-store-badge-cs.svg";
import appStoreBadgeEn from "Assets/Images/Images/app-store-badge-en.svg";
import googlePlayBadgeCs from "Assets/Images/Images/google-play-badge-cs.svg";
import googlePlayBadgeEn from "Assets/Images/Images/google-play-badge-en.svg";
import type { Language } from "Translations/languageConfig";

export const APP_STORE_URL = "https://apps.apple.com/app/id6755823077";

export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=one.mo.app.twa";

type StoreBadgePair = {
  appStore: string;
  playStore: string;
};

const CZECH_BADGES: StoreBadgePair = {
  appStore: appStoreBadgeCs,
  playStore: googlePlayBadgeCs,
};

const ENGLISH_BADGES: StoreBadgePair = {
  appStore: appStoreBadgeEn,
  playStore: googlePlayBadgeEn,
};

export const STORE_BADGES = {
  cs: CZECH_BADGES,
  sk: CZECH_BADGES,
  en: ENGLISH_BADGES,
  pl: ENGLISH_BADGES,
  vi: ENGLISH_BADGES,
  de: ENGLISH_BADGES,
} satisfies Record<Language, StoreBadgePair>;
